import { SWRConfiguration } from 'swr'

import { ErrorResponse, Offerings } from '@infura/packages.api'

import { useApi } from 'lib/api/api'

const defaultConfig = { errorRetryCount: 0, revalidateOnFocus: true, shouldRetryOnError: false }

export default function useOfferings(config?: SWRConfiguration): {
  offerings: Offerings
  loading: boolean
  error?: ErrorResponse
} {
  const { data, error, isLoading } = useApi(['getOfferings'], { ...defaultConfig, ...config })

  return {
    error,
    loading: isLoading,
    offerings: data?.data || { addons: {}, tiers: {} }
  }
}
